<template>
  <div>
    <finance-packs-roi-filters
      :include-archived="includeArchived"
      :min-games="minGames"
      @update:include-archived="onIncludeArchivedChange"
      @update:min-games="onMinGamesChange"
    />
    <b-overlay :show="isLoading" rounded="sm">
      <finance-packs-roi-summary :summary="summary" />
      <finance-packs-roi-table :rows="rows" />
    </b-overlay>
  </div>
</template>

<script>
import { BOverlay } from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import FinancePacksRoiFilters from '@/views/finance/components/FinancePacksRoiFilters.vue'
import FinancePacksRoiSummary from '@/views/finance/components/FinancePacksRoiSummary.vue'
import FinancePacksRoiTable from '@/views/finance/components/FinancePacksRoiTable.vue'

const clamp = (value, min, max) => {
  if (value < min) return min
  if (value > max) return max
  return value
}

const parseMinGames = raw => {
  if (raw == null) return 0
  const parsed = Number.parseInt(raw, 10)
  if (Number.isNaN(parsed)) return 0
  return clamp(parsed, 0, 1000)
}

export default {
  components: {
    BOverlay,
    FinancePacksRoiFilters, FinancePacksRoiSummary, FinancePacksRoiTable,
  },
  setup(_, { root }) {
    const toast = useToast()
    const initialQuery = root.$route.query || {}
    const includeArchived = ref(initialQuery.include_archived === '1')
    const minGames = ref(parseMinGames(initialQuery.min_games))
    const isLoading = ref(false)
    const rows = ref([])
    const summary = ref(null)

    const fetchData = () => {
      isLoading.value = true
      store
        .dispatch('app-finance/fetchPacksRoi', {
          include_archived: includeArchived.value,
          min_games: minGames.value,
        })
        .then(response => {
          const payload = (response.data && response.data.data) || {}
          rows.value = payload.data || []
          summary.value = payload.summary || null
        })
        .catch(err => {
          rows.value = []
          summary.value = null
          toast({
            component: ToastificationContent,
            props: {
              title: err.response?.data?.message || 'Ошибка загрузки отчёта об окупаемости',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          isLoading.value = false
        })
    }

    const syncQuery = () => {
      const next = {
        ...root.$route.query,
        tab: 'packs-roi',
        include_archived: includeArchived.value ? '1' : '0',
        min_games: String(minGames.value),
      }
      const same = (
        root.$route.query.include_archived === next.include_archived
        && root.$route.query.min_games === next.min_games
      )
      if (same) return
      root.$router.replace({ query: next })
    }

    const onIncludeArchivedChange = value => {
      includeArchived.value = !!value
    }
    const onMinGamesChange = value => {
      minGames.value = parseMinGames(value)
    }

    watch([includeArchived, minGames], () => {
      syncQuery()
      fetchData()
    })

    fetchData()

    return {
      includeArchived, minGames, isLoading, rows, summary,
      onIncludeArchivedChange, onMinGamesChange,
    }
  },
}
</script>
